var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNotifications(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19,16.59V8l-.29-.71-4-4L14,3H10l-.71.29-4,4L5,8v8.59l-1.71,1.7L4,20H20l.71-1.71ZM6.41,18l.3-.29L7,17V8.41L10.41,5h3.18L17,8.41V17l.29.71.3.29Zm6.88,3.29,1.42,1.42-1,1L13,24H11l-.71-.29-1-1,1.42-1.42.7.71h1.18ZM14,2H10V1l1-1h2l1,1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotifications);
export default __webpack_public_path__ + "static/1782292452/media/icon-notifications.5caa1f8202531920f0b8df73ce616b17.svg";
export { ForwardRef as ReactComponent };